export const USER_EXIST_ERROR = 'USER ALREADY EXIST';
